import { jsPDF } from "jspdf";
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import SoftBox from "components/SoftBox";
import { CircularProgress, Grid, Icon, MenuItem, Select } from "@mui/material";
import pxToRem from "assets/theme/functions/pxToRem";
import { gql, useLazyQuery } from "@apollo/client";
import EmpleadoLayout from "components/LayoutContainers/EmpleadoLayout";
import boxShadows from "assets/theme/base/boxShadows";
import EditableText from "components/EditableText";
import { formatMoneyPuntoDecimal } from "utils/formatters";
import { formatDate } from "utils/formatters";
import { Money2Text } from "utils/formatters";

const PliegoParticular = () => {
  const currentYear = new Date().getFullYear();
  const documentsRef = useRef(null);
  const { id } = useParams();
  const { lg } = boxShadows;

  const [data, setData] = useState(null);
  const [textArray, setTextArray] = useState([
    "XXX",
    "....................",
    "....................",
    currentYear,
    "....................",
    "....................",
    "....................",
    "......./24",
    "XXX/" + currentYear,
    "....................",
    "00/00 ($......)",
    "....................", //10
    "los X (X) días",
    "....................",
    "....................", //13
    "00:00",
    "DÍA de MES de AÑO",
  ]);
  const [editable, setEditable] = useState(true);
  const [tipoPliego, setTipoPliego] = useState("concurso");

  const [getPedido, { loading }] = useLazyQuery(
    gql`
        query getPedido($id: ID) {
          pedidosCompra(filter: { id: $id }) {
            id
            tipoCompra
            numeroExpediente
            fechaSolicitud
            licitacionInicio
            licitacionFin
            objetoCompra
            domicilioEntrega
            detalles{
              id
              numero
              materiaPrima{
                id
                nombre
                tipoUnidad {
                  nombre
                  multiplicador
                }
              }
              cantidad
              cantidadVerificada
              observacion
              precioEstimado
              nombreServicio
            }
          }
        }
      `,
    {
      onCompleted: (data) => {
        if (!data?.pedidosCompra[0]) return;
        setData(data.pedidosCompra[0]);
      },
    }
  );

  useEffect(() => {
    if (id) {
      getPedido({ variables: { id } });
    }
  }, [id]);

  useEffect(() => {
    if (data) {
      if (data.tipoCompra === "Concurso") {
        setTipoPliego("concurso");
      }
    }
  }, [data]);
  const formatLicitacion = (fechaStr) => {
    const fecha = new Date(fechaStr);
    if (isNaN(fecha)) return "Fecha inválida";

    const dias = [
      "DOMINGO", "LUNES", "MARTES", "MIÉRCOLES", "JUEVES", "VIERNES", "SÁBADO",
    ];
    const meses = [
      "ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO",
      "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE",
    ];

    const diaSemana = dias[fecha.getDay()];
    const dia = fecha.getDate().toString().padStart(2, '0');
    const mes = meses[fecha.getMonth()];
    const año = fecha.getFullYear();

    return `08:00 horas del día ${diaSemana} ${dia} DE ${mes} DE ${año}`;
  };
  const getDiaNombre = (fecha) => {
    const dias = [
      "DOMINGO", "LUNES", "MARTES", "MIÉRCOLES", "JUEVES", "VIERNES", "SÁBADO",
    ];
    return dias[fecha.getDay()];
  };

  const getNextBusinessDay = (date) => {
    const result = new Date(date);
    do {
      result.setDate(result.getDate() + 1);
    } while (result.getDay() === 0 || result.getDay() === 6); // Evita domingo (0) y sábado (6)
    return result;
  };

  const formatRangeFromLicitacionFin = (fechaStr) => {
    const fecha = new Date(fechaStr);
    if (isNaN(fecha)) return "FECHA INVÁLIDA";

    const inicio = getNextBusinessDay(fecha);
    const fin = new Date(inicio);
    fin.setDate(fin.getDate() + 45); // 45 días corridos

    const diaInicio = getDiaNombre(inicio);
    const diaFin = getDiaNombre(fin);

    const fechaInicio = `${inicio.getDate().toString().padStart(2, '0')}/${(inicio.getMonth() + 1).toString().padStart(2, '0')}`;
    const fechaFin = `${fin.getDate().toString().padStart(2, '0')}/${(fin.getMonth() + 1).toString().padStart(2, '0')}`;

    return `${diaInicio} ${fechaInicio} AL ${diaFin} ${fechaFin}`;
  };


  useEffect(() => {
    if (data) {
      const newTextArray = [...textArray];
      newTextArray[0] = data.id;
      newTextArray[1] = data.tipoCompra?.toUpperCase();
      newTextArray[2] = data.objetoCompra || "...";
      newTextArray[6] = formatDate(data.fechaSolicitud, "dd/MM/yyyy") || "--/--/--";
      newTextArray[8] = formatLicitacion(data.licitacionInicio, "dd/MM/yyyy") || "--/--/--";
      newTextArray[9] = formatLicitacion(data.licitacionFin, "dd/MM/yyyy") || "--/--/--";
      newTextArray[14] = data.id || "----/--";
     const total = data.detalles.reduce((acc, detalle) =>
             acc + (detalle.cantidadVerificada * detalle.precioEstimado), 0
           ) || 0;
     
           const formattedTotal = formatMoneyPuntoDecimal(total.toFixed(2));
           newTextArray[17] = "$ " + formattedTotal;
      newTextArray[18] = formatRangeFromLicitacionFin(data.licitacionFin) || "RANGO NO DISPONIBLE";
      newTextArray[19] = "máximo 120 horas hábiles";
      newTextArray[20] = data.domicilioEntrega || "...";
      newTextArray[21] = "EL BIEN Y/O SERVICIO OBJETO DEL PRESENTE CONCURSO DE PRECIOS DEBERÁ REUNIR LAS CARACTERÍSTICAS ESTABLECIDAS A CONTINUACIÓN:";



      setTextArray(newTextArray);
    }
  }, [data]);
  const handleGeneratePdf = async () => {
    setEditable(false);
    const document = documentsRef.current.childNodes[0];
    const doc = new jsPDF({
      format: "a4",
      unit: "px",
      orientation: "portrait",
      hotfixes: ["px_scaling"],
    });

    await doc.html(document, {
      margin: [50, 0, 50, 0],
      callback(doc) {
        doc.save(`exd-pedidoNro-${data.id}-Pliego particular.pdf`);
      },
    });
    setEditable(true);
  };

  const handleTextChange = (e, index) => {
    const newTextArray = [...textArray];
    newTextArray[index] = e.target.innerText;
    setTextArray(newTextArray);
  };

  if (!data) return (
    <EmpleadoLayout>
      <SoftBox display="flex" justifyContent="center" alignItems="center" height="100vh" flexDirection="column" gap={3}>
        {loading ? (<>
          <CircularProgress size={40} color="primary" />
          <SoftTypography variant="h5">Cargando</SoftTypography>
        </>) : (<>
          <Icon fontSize="large">search_off</Icon>
          <SoftTypography variant="h5">No se encontró el pedido</SoftTypography>
        </>)}
      </SoftBox>
    </EmpleadoLayout>
  );

  return (
    <EmpleadoLayout>
      <SoftBox
        p={2}
        display="flex"
        alignItems="center"
        flexDirection="column"
        minHeight="100vh"
        height="100%"
      >
        <div ref={documentsRef}>
          <SoftBox
            sx={{
              position: "relative",
              overflow: "hidden",
              width: "794px",
              backgroundColor: "#ffffff",
              boxShadow: lg,
              px: 6,
            }}
            pb={5}
          >
            {/* ACA VA TODO EL CODIGO */}
            {/* <PdfHeader /> */}

            <SoftBox pb={5}></SoftBox>
            <SoftBox px={1} pb={5}>
              <SoftTypography
                variant="h6"
                fontWeight="bold"
                sx={{
                  textDecorationLine: "underline",
                }}
                textAlign="center"
              >
                {tipoPliego.toUpperCase()} DE PRECIOS N°{" "}
                <EditableText
                  tooltip="Número de Concurso de Precios. Ej: (321)"
                  editable={editable}
                  content={textArray[0]}
                  handleOnBlur={(e) => handleTextChange(e, 0)}
                />
                -UPrO-
                <EditableText
                  tooltip="Año. Ej: (2024)"
                  //editable={editable}
                  content={textArray[3]}
                  handleOnBlur={(e) => handleTextChange(e, 1)}
                />
              </SoftTypography>
              <SoftTypography
                variant="h6"
                fontWeight="bold"
                sx={{
                  textDecorationLine: "underline",
                }}
                textAlign="center"
              >
                PLIEGO PARTICULAR DE CONDICIONES
              </SoftTypography>
            </SoftBox>
            <SoftBox pb={3} textAlign="justify">
              <SoftTypography
                variant="h6"
                fontWeight="bold"
                sx={{
                  textDecorationLine: "underline",
                }}
                textAlign="center"
              >
                OBJETO DEL LLAMADO
              </SoftTypography>
              <SoftTypography variant="body2" pb={3}>
                Llámese a CONCURSO DE PRECIOS,{" "}
                <EditableText
                  tooltip="Descripción del objeto del llamado"
                  editable={editable}
                  content={textArray[2]}
                  handleOnBlur={(e) => handleTextChange(e, 2)}
                />
                , dependiente del MINISTERIO DE EDUCACIÓN{" "}
                .-
              </SoftTypography>
              {tipoPliego === "concurso" && (
                <>
                  <SoftTypography
                    variant="h6"
                    fontWeight="bold"
                    sx={{
                      textDecorationLine: "underline",
                    }}
                    textAlign="center"
                    pb={2}
                  >
                    PRESENTACION DE PROPUESTAS
                  </SoftTypography>
                  <SoftTypography variant="h6" fontWeight="bold">
                    ARTÍCULO 1°.-
                  </SoftTypography>
                  <SoftTypography variant="body2" pb={2}>
                    La publicación del proceso de contratación estará disponible para la presentación de las ofertas como {" "}
                    <EditableText
                      tooltip="plazo"
                      content={textArray[19]}
                      handleOnBlur={(e) => handleTextChange(e, 19)}
                    />
                    ; la fecha exacta de cierre será estipulada en la invitación a cotizar.
                  </SoftTypography>
                  <SoftTypography variant="h6" fontWeight="bold">
                    ARTÍCULO 2°.-
                  </SoftTypography>
                  <SoftTypography variant="body2" pb={2}>
                    El conocimiento, conformidad y aceptación del P.G.U.C y del presente pliego, sus anexos, notas aclaratorias y toda otra documentación emanada de la Sub Dirección de Compras y Contrataciones implica la renuncia expresa de los OFERENTES a todas las acciones y derechos que no se funden en las normas que integran el marco jurídico de este Concurso.
                  </SoftTypography>
                  <SoftTypography variant="h6" fontWeight="bold">
                    ARTÍCULO 3°.-
                  </SoftTypography>
                  <SoftTypography variant="body2" pb={2}>
                    La propuesta económica debe presentarse mediante el Sistema electrónico de Compras en la Universidad Provincial de Oficios (UPRO).-
                  </SoftTypography>
                  <SoftTypography variant="h6" fontWeight="bold">
                    ARTÍCULO 4°.-
                  </SoftTypography>
                  <SoftTypography variant="body2" pb={2}>
                    La propuesta económica deberá estar conformada por:
                  </SoftTypography>
                  <SoftTypography variant="body2" pb={1} style={{ paddingLeft: '2em' }}>
                    a)   Oferta económica: El/Los precio/s unitario/s, expresado/s en PESOS con IVA incluido.
                  </SoftTypography>
                  <SoftTypography variant="body2" pb={1} style={{ paddingLeft: '2em' }}>
                    b)  Especificaciones técnicas y/o información anexa que conformen la propuesta.
                  </SoftTypography>
                  <SoftTypography variant="body2" pb={1} style={{ paddingLeft: '2em' }}>
                    c)   En  caso  de  cumplir  con  criterios  de  sustentabilidad  o  normas  de  calidad,  se deberá adjuntar la documentación pertinente que los/as avale.
                  </SoftTypography>
                  <SoftTypography variant="body2" pb={1} style={{ paddingLeft: '2em' }}>
                    d)  La oferta deberá responder a las características del bien/elemento/servicio solicitado y no a aproximaciones, sea en tamaño, capacidad, volumen, peso, rendimiento o cualquier otra   característica,   salvo   las   variaciones   que   taxativamente   se   permitan   en   la documentación adjunta del proceso.
                    La oferta no podrá ser condicionada bajo ningún concepto. Cualquier aclaración en cuanto a cantidad, forma y plazo de entrega y/o pago, descuento, recargo, validez temporal, etc. será considerada un condicionamiento y originará el inmediato rechazo de la misma. Sólo podrán permitirse entregas parciales si la Unidad Ejecutora manifiesta taxativamente la necesidad del
                    Página 1bien y acepta otorgar prórrogas en las entregas, situación que deberá manifestarse en forma previa a la convocatoria en la documentación adjunta del proceso.
                  </SoftTypography>
                </>
              )}
            </SoftBox>
            <SoftBox pb={3} textAlign="justify">
              <SoftTypography
                variant="h6"
                fontWeight="bold"
                sx={{
                  textDecorationLine: "underline",
                }}
                textAlign="center"
              >
                FECHA DE APERTURA
              </SoftTypography>
              <SoftTypography variant="h6" fontWeight="bold">
                ARTÍCULO 5°.-
              </SoftTypography>
              <SoftTypography variant="body2">
                Las Ofertas de este Concurso de Precios podrán presentarse hasta las{" "}
                <EditableText
                  tooltip="Plazo de presentación de ofertas, se actualiza cuando se activa el proceso de contratación"

                  content={textArray[9]}
                  handleOnBlur={(e) => handleTextChange(e, 9)}
                />
                , fecha en que se procederá a la apertura de las propuestas. -
              </SoftTypography>
            </SoftBox>
            <SoftBox pb={3} textAlign="justify">
              <SoftTypography
                variant="h6"
                fontWeight="bold"
                sx={{
                  textDecorationLine: "underline",
                }}
                textAlign="center"
              >
                CONSULTAS, CIRCULARES, ACLARATORIAS Y ADENDAS
              </SoftTypography>
              <SoftTypography variant="h6" fontWeight="bold">
                ARTÍCULO 6°.-
              </SoftTypography>
              <SoftTypography variant="body2">
                Las consultas sobre este Pliego y/o sobre la contratación en general podrán ser realizadas a través del mail institucional compras@uprosanluis.edu.ar de la Sub dirección de Compras y Contrataciones hasta no más de veinticuatro (24) antes del momento informado para el cierre del mismo.
                La Subdirección de Compras y Contrataciones queda facultada a solicitar aclaraciones y toda información que considere oportuna, a la Unidad Ejecutora, en cualquier momento del proceso. Asimismo, podrá emitir Circulares Aclaratorias o Adendas mientras el proceso esté disponible para la presentación de las Ofertas, las que se notificarán a través de la publicación como parte de la documentación del proceso. -
              </SoftTypography>
            </SoftBox>
            <SoftBox pb={3} textAlign="justify">
              <SoftTypography
                variant="h6"
                fontWeight="bold"
                sx={{
                  textDecorationLine: "underline",
                }}
                textAlign="center"
              >
                MANTENIMIENTO MÍNIMO DE LA OFERTA
              </SoftTypography>
              <SoftTypography variant="h6" fontWeight="bold">
                ARTÍCULO 7°.-
              </SoftTypography>
              <SoftTypography variant="body2">
                El Oferente deberá mantener la oferta por el término de treinta (30) días hábiles.
              </SoftTypography>
            </SoftBox>
            <SoftBox pb={3}>
              <SoftTypography
                variant="h6"
                fontWeight="bold"
                sx={{
                  textDecorationLine: "underline",
                }}
                textAlign="center"
              >
                PLAZO MÁXIMO DE ENTREGA
              </SoftTypography>
              <SoftTypography variant="h6" fontWeight="bold">
                ARTÍCULO 8°.-
              </SoftTypography>
              <SoftTypography variant="body2">
                El bien y/o servicio solicitado, objeto del presente concurso de precios, deberá ser prestado y/o entregado en {" "}
                <EditableText
                  tooltip="Plazo y domicilio de entrega"
                  editable={editable}
                  content={textArray[20]}
                  handleOnBlur={(e) => handleTextChange(e, 20)}
                />
                {" "}una vez notificada la correspondiente orden de provisión en el domicilio electrónico constituido.–
              </SoftTypography>
            </SoftBox>
            <SoftBox pb={3} textAlign="justify">
              <SoftTypography
                variant="h6"
                fontWeight="bold"
                sx={{
                  textDecorationLine: "underline",
                }}
                textAlign="center"
              >
                DETALLE DEL SERVICIO
              </SoftTypography>
              <SoftTypography variant="h6" fontWeight="bold">
                ARTÍCULO 9°.-
              </SoftTypography>
              <SoftTypography variant="body2">
                <EditableText
                  editable={editable}
                  content={textArray[21]
                  } />
              </SoftTypography>
              <SoftBox
                p={2}
                border="1px solid black"
                bgcolor="#ffffff"
                fontSize="0.9rem"
              >
                <strong>Observaciones:</strong> La entrega se debe realizar en Comedor Upro, con domicilio en Calle Belgica S/N entre Madre Cabrini y Maipu, de la ciudad de Villa Mercedes (San Luis). <strong>La descarga de los materiales queda a cargo del Proveedor.</strong>
              </SoftBox>
              <Grid //Tabla de items
                container
                my={4}
                sx={{
                  border: "1px solid black",
                  borderBottom: "none",
                }}
              >
                <Grid
                  xs={2}
                  textAlign="center"
                  sx={{
                    borderRight: "1px solid black",
                    borderBottom: "1px solid black",
                    backgroundColor: "rgb(206,206,240)",
                  }}
                >
                  Item
                </Grid>
                <Grid
                  xs={5}
                  textAlign="center"
                  sx={{
                    borderRight: "1px solid black",
                    borderBottom: "1px solid black",
                    backgroundColor: "rgb(206,206,240)",
                  }}
                >
                  Descripción
                </Grid>
                <Grid
                  xs={3}
                  textAlign="center"
                  sx={{
                    borderRight: "1px solid black",
                    borderBottom: "1px solid black",
                    backgroundColor: "rgb(206,206,240)",
                  }}
                >
                  Cantidad
                </Grid>
                <Grid
                  xs={2}
                  textAlign="center"
                  sx={{
                    borderBottom: "1px solid black",
                    backgroundColor: "rgb(206,206,240)",
                  }}
                >
                  Unidad
                </Grid>
                {data.detalles.map((detalle, index) => (<React.Fragment key={index}>
                  <Grid
                    xs={2}
                    textAlign="center"
                    sx={{
                      borderRight: "1px solid black",
                      borderBottom: "1px solid black",
                    }}
                  >
                    <SoftTypography variant="caption">
                      {index + 1}
                    </SoftTypography>
                  </Grid>
                  <Grid
                    xs={5}
                    textAlign="left"
                    sx={{
                      borderRight: "1px solid black",
                      borderBottom: "1px solid black",
                      lineHeight: 1,
                      pb: 1,
                      px: 1
                    }}
                  >
                    <SoftTypography variant="caption">
                      {detalle.materiaPrima?.nombre ?? detalle.nombreServicio}
                    </SoftTypography>
                  </Grid>
                  <Grid
                    xs={3}
                    textAlign="center"
                    sx={{
                      borderRight: "1px solid black",
                      borderBottom: "1px solid black",
                    }}
                  >
                    <SoftTypography variant="caption">
                      {detalle.cantidadVerificada ?? "-"}
                    </SoftTypography>
                  </Grid>
                  <Grid
                    xs={2}
                    textAlign="center"
                    sx={{
                      borderBottom: "1px solid black",
                    }}
                  >
                    <SoftTypography variant="caption">
                      {detalle.materiaPrima?.tipoUnidad?.nombre ?? "-"}
                    </SoftTypography>
                  </Grid>
                </React.Fragment>))}
              </Grid>
              <SoftTypography variant="body2" pb={2} paddingLeft={2} fontWeight="bold">
                Los anexos correspondientes a Especificaciones Técnicas e Imágenes incorporadas al expediente y/o adjuntados a la invitación a participar del Concurso de Precios forman parte del presente Pliego Particular, debiendo ser consideradas al momento de la presentación y evaluación de ofertas. –
              </SoftTypography>
            </SoftBox>
            {/* <SoftBox pb={3} textAlign="justify">
              <SoftTypography
                variant="body2"
                textAlign="justify"
                pb={2}
                >
                  <EditableText
                      tooltip="Número de Concurso de Precios"
                      editable={editable}
                      content={textArray[2]}
                      handleOnBlur={(e) => handleTextChange(e, 2)}
                    />
                </SoftTypography>
              </SoftBox>                   */}
            <SoftBox pb={3} textAlign="justify">
              <SoftTypography
                variant="h6"
                fontWeight="bold"
                sx={{
                  textDecorationLine: "underline",
                }}
                textAlign="center"
              >
                EVALUACIÓN DE OFERTAS
              </SoftTypography>
              <SoftTypography variant="h6" fontWeight="bold">
                ARTÍCULO 10°.-
              </SoftTypography>
              <SoftTypography variant="body2">
                Las ofertas serán evaluadas por el área solicitante y/o la Comisión Evaluadora que
                se designe al efecto debiendo preferir las que resulten más convenientes a los
                intereses de la Universidad y la satisfacción de las necesidades que fundamentarán
                la solicitud. Efectuada la selección deberá comunicarla a la Subdirección Compras y
                Contrataciones a fin de que éste las notifique a los oferentes; quienes podrán
                dentro del plazo de 24 hs. subsiguientes a la notificación, solicitar las
                aclaraciones o efectuar las impugnaciones que consideren pertinentes las que serán
                resueltas por el área legal previo informe del área solicitante. -
              </SoftTypography>
            </SoftBox>
            <SoftBox pb={4} textAlign="justify">
              <SoftTypography
                variant="h6"
                fontWeight="bold"
                sx={{
                  textDecorationLine: "underline",
                }}
                textAlign="center"
              >
                CONDICIONES PARA EL PAGO
              </SoftTypography>
              <SoftTypography variant="h6" fontWeight="bold">
                ARTÍCULO 11°.-
              </SoftTypography>
              <SoftTypography variant="body2">
                El pago de las facturas correspondientes a la prestación de servicios y/o entrega de
                bienes se efectuará previa certificación de la finalización del mismo por parte del
                área solicitante.
              </SoftTypography>
            </SoftBox>
            <Grid container spacing={2} justifyContent="end">
              <Grid item xs={5} textAlign="center">
                <SoftBox
                  style={{
                    borderBottom: "1px solid black",
                    width: "100%",
                    display: "inline-block",
                    marginBottom: "0.5rem",

                  }}
                ></SoftBox>
                <SoftTypography variant="body2" fontSize="0.8rem" alignItems="center">
                  Jessica B. Zafra
                </SoftTypography>
                <SoftTypography variant="body2" fontSize="0.8rem" alignItems="center">
                  Directora de Compras y Contrataciones
                </SoftTypography>
                <SoftTypography variant="body2" fontSize="0.8rem" alignItems="center">
                  Universidad Provincial de Oficios EVA PERON
                </SoftTypography>
              </Grid>
            </Grid>
          </SoftBox>
        </div>
        <SoftBox
          variant="contained"
          bgColor="white"
          p={2}
          style={{
            position: "fixed",
            bottom: "1.5rem",
            right: "1.5rem",
            zIndex: 1000,
            boxShadow:
              "inset 0rem 0rem 0.0625rem 0.0625rem rgb(255 255 255 / 90%), 0rem 1.25rem 1.6875rem 0rem rgb(0 0 0 / 5%)",
            borderRadius: "16px",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            backdropFilter: `saturate(200%) blur(${pxToRem(30)})`,
          }}
        >
          <Grid container spacing={2} justifyContent="flex-end" id="button">
            <Grid item>
              <SoftButton variant="gradient" color="error" onClick={handleGeneratePdf}>
                <Icon fontWeight="bold">picture_as_pdf</Icon>
                &nbsp;&nbsp;Descargar PDF
              </SoftButton>
            </Grid>
          </Grid>
        </SoftBox>
      </SoftBox>
    </EmpleadoLayout>
  );
};

export default PliegoParticular;
